import { DataBean } from "../DataBean";

export class ProductionOrderDocuments extends DataBean {



    public async getProductionOrderDocuments(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderDocuments_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }

    
}